import React from "react";

export const LocaleContext = React.createContext();
export const LangageProvider = ({ children, locale }) => {
    return (
        <LocaleContext.Provider value={{ locale}}>
            {children}
        </LocaleContext.Provider>
    );
};